<template>

    <div>

        <div class="py-3 px-3 bg-white shadow-sm text-dark d-flex justify-content-between">

            <div>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <i class="fas fa-bars"></i>
                </button>
            </div>

            <div v-if="model.app.id" class="d-flex align-items-center mx-3">

                <div style="width: 34px; height: 34px;" class="rounded" :style="{ backgroundColor: blockColor }">
                    <div class="d-flex flex-column align-items-center mx-auto h-100">
                        <i :class="iconClass" class="m-auto fa-lg" :style="{ color: themeColor }"></i>
                    </div>
                </div>

                <div class="ms-2">
                    {{model.app.name}}
                </div>

            </div>

            <div v-else class="headline text-uppercase">
                <span class="text-primary">we</span>base
            </div>

            <div>
                <i class="far fa-bell"></i>
            </div>

        </div>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mt-3">
                <li class="nav-item">
                    <a href="javascript:void(0)" @click="onWorkspaceClick" class="nav-link ms-5">
                        Workspace
                    </a>
                </li>

                <li class="nav-item" v-if="model.app.id && model.currentCollaboratorId">
                    <a href="javascript:void(0)" @click="onOpenClick" class="nav-link ms-5">
                        Open App
                    </a>
                </li>

                <li class="nav-item" v-if="model.app.id && model.currentCollaboratorId && isEditAuthorized">
                    <a href="javascript:void(0)" @click="onEditClick" class="nav-link ms-5">
                        Edit App
                    </a>
                </li>

                <li class="nav-item" v-if="model.app.id && model.currentCollaboratorId && isEditAuthorized">
                    <a href="javascript:void(0)" @click="onCollaboratorsClick" class="nav-link ms-5">
                        App Users
                    </a>
                </li>
            </ul>

        </div>

    </div>
</template>

<script>
    export default {
        name: 'MobileNav',
        data() {
            return {
                model: webase.model,
                collapsed: false
            }
        },
        mounted() {
            $('.nav-link').on('click', function () {
                console.log('MobileNav, nav-link click')
                $('.navbar-collapse').collapse('hide');
            });
        },
        computed: {
            blockColor() {
                if (this.model.app.theme_color) {
                    return this.model.app.theme_color + '40'
                }

                return this.defaultThemeColor + '40'
            },
            themeColor() {
                if (this.model.app.theme_color) {
                    return this.model.app.theme_color
                }

                return this.defaultThemeColor
            },
            iconClass() {
                if (this.model.app.icon_class) {
                    return this.model.availableIcons[this.model.app.icon_class]
                }

                let randomIcon = webase.utils.array.random(webase.model.iconOptions)
                return this.model.availableIcons[randomIcon]
            },
            isEditAuthorized() {
                let collaborator = webase.managers.app.currentCollaborator()
                return webase.utils.auth.isEditAuthorized(this.model.app.user_app_uuid, collaborator)
            }
        },
        methods: {
            onWorkspaceClick() {
                this.$router.push({ name: 'apps' })
                $('.navbar-collapse').collapse('hide');
            },
            onOpenClick() {
                this.$router.push({ name: 'open-app', params: {id: this.model.app.id}})
                $('.navbar-collapse').collapse('hide');
            },
            onEditClick() {
                this.$router.push({ name: 'app-editor', params: {id: this.model.app.id}})
                $('.navbar-collapse').collapse('hide');
            },
            onCollaboratorsClick() {
                this.$router.push({ name: 'collaborators', params: {id: this.model.app.id}})
                $('.navbar-collapse').collapse('hide');
            }
        }
    }
</script>
